import React, { FunctionComponent } from 'react'
import { useFeathersClient } from '@strac/react-client-feathers'
import { useQuery } from '@tanstack/react-query'
import { getAllData } from '../../../utils/data'
import { Button, Card, List } from 'antd'
import { Collection } from 'server'
import CollectionsListItem from './CollectionsListItem/CollectionsListItem'
import useQueryListener from '../../../hooks/data/useQueryListener'
import { FileAddFilled } from '@ant-design/icons'

interface IProps {
  userId: number
  search: string
  setSelectedCollection: (value: Collection | undefined) => void
  setOpen: (value: boolean) => void
}

const CollectionsList: FunctionComponent<any> = (props: IProps) => {
  const { search, setSelectedCollection, setOpen, userId } = props

  const client = useFeathersClient()

  const collectionsQuery = {
    user_id: userId,
    active: true,
    $sort: {
      name: 1
    }
  }
  const {
    data: collections,
    isLoading: collectionsLoading,
    refetch
  } = useQuery({
    queryKey: ['collection', 'find', collectionsQuery],
    queryFn: () => getAllData(client, 'collection', collectionsQuery),
    gcTime: 0
  })

  useQueryListener('collection', refetch)

  const filteredC = collections?.filter((c: Collection) => {
    return c.name.toLowerCase().includes(search.toLowerCase())
  })

  const renderItem = (c: Collection) => (
    <CollectionsListItem setSelectedCollection={setSelectedCollection} collection={c} />
  )

  return (
    <Card
      style={{
        height: '100%',
        overflow: 'auto'
      }}
      styles={{
        body: {
          padding: 0
        }
      }}
    >
      <List
        header={
          <div style={{ display: 'flex', justifyContent: 'flex-end', paddingRight: '12px' }}>
            <Button type={'primary'} icon={<FileAddFilled />} onClick={() => setOpen(true)}>
              Create
            </Button>
          </div>
        }
        size={'small'}
        loading={collectionsLoading}
        dataSource={filteredC}
        renderItem={renderItem}
      />
    </Card>
  )
}

export default CollectionsList
